import angular from 'angular';
import { OrderDetailsComponent } from './order-details.component';
import { OrderDetailsService } from './order-details.service';
import { OrderShippingInfoModule } from './order-shipping-info/order-shipping-info.module';
import { OrderShipmentsModule } from './order-shipments/order-shipments.module';
import { OrderDiscountsModule } from './order-discounts/order-discounts.module';
export var OrderDetailsModule = angular
    .module('eeComUiApp.orderDetails', [
    OrderShippingInfoModule,
    OrderShipmentsModule,
    OrderDiscountsModule
])
    .service('OrderDetailsService', OrderDetailsService)
    .component('orderDetails', OrderDetailsComponent)
    .name;
//# sourceMappingURL=order-details.module.js.map